import React, { useState, useEffect, useMemo } from "react"
import PropTypes from "prop-types"
import { 
  Card,
  Row,
  Button,
  ModalBody,
  ModalFooter,
  Col,
  Input,
  FormGroup,
  Label
} from "reactstrap"
import TableContainer from "../../../components/Common/TableContainer";
import i18n from "../../../i18n"
import Slider from "react-rangeslider"
import "react-rangeslider/lib/index.css"
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Spinners from "../../../components/Common/Spinner"

const Step2 = (props) => {

  const { toggle, setStep, setSelectRouting, selectRouting, setShowModalDestination, setGroupDestinationRoutingModal, setSelectedRoutingDestination  } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(onGetModifyRouting());
  }, [dispatch]);

  const labels = {
    1: "0",
    2: "5",
    3: "10",
    4: "15",
    5: "20",
    6: "25",
    7: "30",
    8: "35",
    9: "40",
    10: "45",
    11: "50",
    12: "55"
  }

  const [custom_val, setcustom_val] = useState(5)
  const [arrGroupDestination, setArrGroupDestination] = useState([]);
  const [isLoading, setLoading] = useState(true)

  const sendRequest = () => {
    setStep(1);
    setSelectRouting(null);
    setShowModalDestination(true)
    setGroupDestinationRoutingModal(false)
    setSelectedRoutingDestination({id: selectRouting.serviceNumber, countItem: (arrGroupDestination.length)})
  }

  const onClickAddArr = (data, e) => {
    let arr = arrGroupDestination;
    if(e.target.checked){
      arr.push(data)
      setArrGroupDestination(arr)
    }
    else{
      let checkGroupDestination = arr.filter(function(opt) { 
        return opt.id === data.id
      });
      if(checkGroupDestination.shift()){
        arr.splice(arr.indexOf(checkGroupDestination.shift()), 1);
      }
    }
  }
  
  const onClicklBack = () => {
    setStep(1);
    setSelectRouting(null);
  }

  const handleOrderClicks = () => {
    setOrder("");
    setIsEdit(false);
    toggle();
  };

  const handleOrderClick = (arg) => {
    const order = arg;
    setOrder({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderDate: order.orderDate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeClass: order.badgeClass,
    });

    setIsEdit(true);

    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "",
        accessorKey: "id",
        cell: (cellProps) => (
          <FormGroup className="font-size-16">
            <Label className="form-check form-check-danger">
              <Input type="checkbox" id={`check-${cellProps.row.original.id}`} onClick={(e) => onClickAddArr(cellProps.row.original, e)} />
            </Label>
          </FormGroup>
        ),
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("ServiceNumber"),
        accessorKey: 'serviceNumber',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: i18n.t("StartingPoint"),
        accessorKey: 'startingPoint',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Destination"),
        accessorKey: 'destination',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Passengers"),
        accessorKey: 'passengers',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Scales"),
        accessorKey: 'numberScales',
        enableColumnFilter: false,
        enableSorting: true
      }
    ],
    [handleOrderClick, setGroupDestinationRoutingModal]
  );

  return (
    <Card>
      <ModalBody>
        <p>{i18n.t("ModifyAddresses")}</p>
        <p>{i18n.t("SelectedService")}</p>
        <p>{`${i18n.t("StartingPoint")}: ${selectRouting.startingPoint}`}</p>
        <p>{`${i18n.t("Destination")}: ${selectRouting.destination}`}</p>
        <p>{i18n.t("ServiceToBeGrouped")}</p>
        <Col xl={12} md={12}>
          <h5 className="font-size-14 mb-3 mt-0">{i18n.t("KilometersDistance")}</h5>
          <Slider
            value={custom_val}
            min={1}
            max={12}
            labels={labels}
            orientation="horizontal"
            onChange={value => {
              setcustom_val(value)
            }}
          />
        </Col>
        <Col className="pt-4">
          { isLoading ? <Spinners setLoading={setLoading} /> : 
            <TableContainer
              columns={columns}
              data={[]}
              isGlobalFilter={false}
              isAddButton={false}
              isCustomPageSize={false}
              handleUserClick={handleOrderClicks}
              isPagination={true}
              SearchPlaceholder="26 records..."
              buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
              buttonName=""
              tableClass="table table-bordered mb-0 fs-12"
              theadClass=""
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          }
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button className="btn-danger" type="button" color="secondary" onClick={sendRequest}>
          {i18n.t("Continue")}
        </Button>
        <Button
          className="btn-light"
          type="button"
          color="secondary"
          data-dismiss="modal"
          onClick={onClicklBack}
        >
          {i18n.t("Back")}
        </Button>
      </ModalFooter>
    </Card>
  )
}

Step2.propTypes = {
  setStep: PropTypes.func,
  setSelectRouting: PropTypes.func,
  toggle: PropTypes.func,
  setShowModalDestination: PropTypes.func,
  setGroupDestinationRoutingModal: PropTypes.func,
  setSelectedRoutingDestination: PropTypes.func,
  selectRouting: PropTypes.object
}

export default Step2;
